import { memo, useState, useEffect } from 'react';
import { Modal } from "semantic-ui-react";
import Spinner from "./Spinner";

const base64ToBlob = (base64Data) => {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: 'application/pdf' });
}

const ViewPdf = memo(({ label, pdfData, onLoad = () => { } }) => {
    const [blobUrl, setBlobUrl] = useState(null);

    useEffect(() => {
        let url = null;
        if (pdfData) {
            try {
                const blob = base64ToBlob(pdfData);
                url = URL.createObjectURL(blob);
                setBlobUrl(url);
            } catch (e) {
                console.error("Error creating PDF blob:", e);
            }
        } else {
            setBlobUrl(null);
        }
        return () => {
            if (url) {
                URL.revokeObjectURL(url);
            }
        };
    }, [pdfData]);

    return <Modal
        className="fullscreenModal"
        style={{
            position: "absolute !important", top: "0px", left: "0px", width: "100%",
            height: "100%", padding: "0px !important", margin: "0px !important"
        }}
        centered={false}
        dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
        trigger={<span style={{ color: "#4183C4", cursor: "pointer" }}>{label}</span>}
        onOpen={onLoad}
        closeOnDimmerClick={true}
        content={blobUrl ?
            <embed src={blobUrl} type="application/pdf" width="100%" height="99.6%" />
            :
            <><Spinner /></>}
        actions={[{ key: 'done', content: 'Close', negative: true }]}
    />
});

export default ViewPdf;